export const loginFields = [
    {
        customLabelName: "Email",
        fieldName: "email",
        type: "email",
        placeholder: "Enter your email",
        required: true
    },
    {
        customLabelName: "Password",
        fieldName: "password",
        type: "password",
        placeholder: "Enter your password",
        required: true,
        showPasswordToggle: true
    },
];
